/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Gdpr_SubInputs */

const en_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const de_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konform`)
};

const fr_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const es_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const it_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const nl_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const pl_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const fi_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const da_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const sv_landing_compliance_gdpr_sub = /** @type {(inputs: Landing_Compliance_Gdpr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

/**
* | output |
* | --- |
* | "Compliant" |
*
* @param {Landing_Compliance_Gdpr_SubInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_gdpr_sub = /** @type {((inputs?: Landing_Compliance_Gdpr_SubInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Gdpr_SubInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_gdpr_sub(inputs)
	if (locale === "fr") return fr_landing_compliance_gdpr_sub(inputs)
	if (locale === "es") return es_landing_compliance_gdpr_sub(inputs)
	if (locale === "it") return it_landing_compliance_gdpr_sub(inputs)
	if (locale === "nl") return nl_landing_compliance_gdpr_sub(inputs)
	if (locale === "pl") return pl_landing_compliance_gdpr_sub(inputs)
	if (locale === "fi") return fi_landing_compliance_gdpr_sub(inputs)
	if (locale === "da") return da_landing_compliance_gdpr_sub(inputs)
	if (locale === "sv") return sv_landing_compliance_gdpr_sub(inputs)
	return en_landing_compliance_gdpr_sub(inputs)
});